export function swiper() {
    document.addEventListener('DOMContentLoaded', () => {
        const swiper = new Swiper('.swiper', {
            loop: true, // ループを有効にする
            slidesPerView: 3.5, // 一度に表示するスライドの数
            speed: 4000, // スライドの切り替え速度（ミリ秒）
            allowTouchMove: false, // スワイプを無効にする
            autoplay: {
                delay: 0, // スライドの遅延（ミリ秒）、0で途切れなくループ
                disableOnInteraction: false, // ユーザーが操作しても自動スクロールを停止しない
            },
        });
    });
}